import { useMutation, useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";

interface IPostAddSectirRequest {
    sectorName: string;
}

async function postAddSector(data: IPostAddSectirRequest): Promise<BaseResponse<any>> {
    try {
        const response = await axiosInstance.post("/Merchant/AddSector", data);
        return response.data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function usePostAddSector(data: IPostAddSectirRequest) {
    return useMutation<any | undefined, Error, IPostAddSectirRequest>(
        (data) => postAddSector(data)
    );
}
